import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';

@Component({
  selector: 'app-summarymailprogress',
  templateUrl: './summarymailprogress.component.html',
  styleUrls: ['./summarymailprogress.component.scss']
})
export class SummarymailprogressComponent implements OnInit {

  public errMessage: string;
  constructor(private data: DataService, private router: Router, private location: Location) { }


  ngOnInit(): void {
    this.errMessage = "Sending mail, please wait...."
    this.SendMail();
  }

  SendMail(): void {
    this.data.request<string>("kiosk/propertysummary",null,"GET").subscribe((e)=>{
      this.location.back();
    },(error)=>{
      /*
      this.errMessage = "Failed to send the mail, please try again";
      console.error(error);
      this.delay(3000).then((v) => {
        this.location.back();
      })*/
      this.location.back();

    })
  }
  

 delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }
}
